// extracted by mini-css-extract-plugin
export var arrows = "_l-6";
export var decrementer = "_l-a";
export var disabled = "_l-4";
export var error = "_l-1";
export var hiddenText = "_l-b";
export var incrementer = "_l-9";
export var input = "_l-8";
export var inputWrapper = "_l-0";
export var leadingIcon = "_l-c";
export var readonly = "_l-3";
export var regular = "_l-7";
export var small = "_l-5";
export var warning = "_l-2";